// removed by extract-text-webpack-plugin
module.exports = {"recordExportForm":"styles__recordExportForm___29oiH","submit":"styles__submit___1RrJW","notice":"styles__notice___2ITGM"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/recordExportForm/styles.scss
// module id = 536
// module chunks = 0